// Penny drop — PROPOSED backend contract.
//
// The client hasn't approved penny drop yet, so investor-service doesn't send
// these statuses today. The frontend is built against them so the approved
// Figma flow works the day the backend ships; until then every account falls
// through to today's behaviour (statement upload → success screen). If the
// backend picks different names, this file is the only place to change.
//
// Where the frontend reads them: `accountStatus` on the statement-upload
// response and on GET bank account detail (polled while in progress).
export const PENNY_DROP_ACCOUNT_STATUS = {
  IN_PROGRESS: 'penny_drop_in_progress',
  COMPLETED: 'penny_drop_completed',
  FAILED: 'penny_drop_failed',
} as const

/**
 * What the Add Bank Account dialog shows after the statement upload.
 * `delayed` = still in progress when polling gave up; the investor is told
 * they'll be notified by email.
 */
export type PennyDropState = 'progress' | 'success' | 'failed' | 'delayed'

// How often the account is re-fetched while the deposit is in flight, and when
// the dialog stops waiting.
export const PENNY_DROP_POLL_INTERVAL_MS = 3000
export const PENNY_DROP_POLL_TIMEOUT_MS = 60_000

/**
 * Backend account status → dialog state. Anything that isn't an explicit
 * penny-drop status (e.g. today's `pending_verification`) keeps the current
 * flow: the upload went through, so the success screen shows.
 */
export const toPennyDropState = (accountStatus: string | null | undefined): PennyDropState => {
  if (accountStatus === PENNY_DROP_ACCOUNT_STATUS.IN_PROGRESS) return 'progress'
  if (accountStatus === PENNY_DROP_ACCOUNT_STATUS.FAILED) return 'failed'
  return 'success'
}
